module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "createReservationTopArea"
  }, [_c('div', {
    staticClass: "row mt-0"
  }, [_c('div', {
    staticClass: "col-sm-9 font-weight-600 fs-largest"
  }, [_c('span', [_vm._v(_vm._s(this.reservation.product.name))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 font-weight-600 fs-largest text-right"
  }, [(this.reservation.sequencialNumber) ? _c('span', [_vm._v("#" + _vm._s(this.reservation.sequencialNumber))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row mt-0"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "bold dark fs-small"
  }, [_vm._v("Location:")]), _vm._v(" "), _c('div', {
    staticClass: "bold py-1"
  }, [_vm._v(_vm._s(_vm.location))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "bold dark fs-small"
  }, [_vm._v("Departure:")]), _vm._v(" "), _c('div', {
    staticClass: "bold py-1"
  }, [_vm._v(_vm._s(_vm.departure))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "bold dark fs-small"
  }, [_vm._v("Duration:")]), _vm._v(" "), _c('div', {
    staticClass: "bold py-1"
  }, [_vm._v(_vm._s(_vm.hourToDuration(this.reservation.event.duration)))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 resourceSelectorNewReservation"
  }, [_c('div', {
    staticClass: "bold dark fs-small"
  }, [_vm._v("Resource:")]), _vm._v(" "), _c('v-select', {
    class: {
      'notAllowed': _vm.isResourceDropdownDisabled
    },
    attrs: {
      "options": _vm.resourcesWithAvailability,
      "disabled": _vm.isResourceDropdownDisabled,
      "label": "name",
      "placeholder": _vm.resourcePlaceholder
    },
    model: {
      value: (_vm.reservation.selectedResource),
      callback: function($$v) {
        _vm.$set(_vm.reservation, "selectedResource", $$v)
      },
      expression: "reservation.selectedResource"
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a040eb8"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/NewReservation/Resume/Details/TopArea.vue
// module id = 2468
// module chunks = 0